import { useCallback, useState } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { notificationApiRef } from '../../../../../apis/notificationApi';
import { iqeAgentApiRef } from '../../../../../apis/iqeAgentApi';
import { toIqeProjectRunsDomain } from '../dto/responseDto/projectRuns.response.dto';
import type { TestRun } from '../interfaces/ui';

export const useProjectRuns = () => {
  const notificationApi = useApi(notificationApiRef);
  const iqeAgentApi = useApi(iqeAgentApiRef);
  const [runs, setRuns] = useState<TestRun[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [hasFetchedOnce, setHasFetchedOnce] = useState(false);

  const fetchRuns = useCallback(
    async (apmNumber: string, projectId: string) => {
      setLoading(true);
      setError(null);
      try {
        const response = await iqeAgentApi.getIqeProjectRuns(
          apmNumber,
          projectId,
        );
        setRuns(toIqeProjectRunsDomain(response));
      } catch (requestError) {
        const message = `Error: ${(requestError as Error).message}`;
        setError(message);
        notificationApi.sendNotification({
          message,
          disapperAfterMs: 4000,
          severity: 'error',
        });
      } finally {
        setLoading(false);
        setHasFetchedOnce(true);
      }
    },
    [notificationApi, iqeAgentApi],
  );

  return { runs, loading, error, hasFetchedOnce, fetchRuns };
};
